import Mutations from '../../../store/data/mutations'
export default {
  namespaced: true,
  state: {
    approvedBillLines: [],
    filterBy: '',
    drawer: false,
    loadingApprovedBillLines: false,
    selected: [],
    selectedAll: false,
    dates: [],
    filterBy: null,
    filterCol: null,
    fetchApprovedBillLines: false
  },
  mutations: Mutations
}
